import { __rest } from '../node_modules/tslib/tslib.es6.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Button } from '../Components/ui/button.js';
import { TooltipProvider, Tooltip, TooltipTrigger, TooltipContent } from '../Components/ui/tooltip.js';
import { cn } from '../lib/utils.js';

const Actions = (_a) => {
    var { className, children } = _a, props = __rest(_a, ["className", "children"]);
    return (jsx("div", Object.assign({ className: cn('tw:inline-flex tw:items-center tw:gap-2 tw:rounded-[10px] tw:bg-[#f6f8fa] tw:p-2', className) }, props, { children: children })));
};
const Action = (_a) => {
    var { tooltip, children, label, className } = _a, props = __rest(_a, ["tooltip", "children", "label", "className"]);
    const button = (jsxs(Button, Object.assign({ className: cn('tw:relative tw:!size-8 tw:cursor-pointer tw:rounded-[8px] tw:bg-white tw:!p-0 tw:text-foreground tw:hover:bg-gray-50 tw:[&_svg]:!size-5', className), type: "button", variant: "ghost" }, props, { children: [children, jsx("span", Object.assign({ className: "tw:sr-only" }, { children: label || tooltip }))] })));
    if (tooltip) {
        return (jsx(TooltipProvider, { children: jsxs(Tooltip, { children: [jsx(TooltipTrigger, Object.assign({ asChild: true }, { children: button })), jsx(TooltipContent, { children: jsx("p", { children: tooltip }) })] }) }));
    }
    return button;
};

export { Action, Actions };
//# sourceMappingURL=actions.js.map
